module.exports = __webpack_public_path__ + "img/15.d41dd977.png";